export default [
  { name: 'Name', prop: 'name', type: 'text' },
  { name: 'Category', prop: 'resource_category_id', type: 'autocomplete', references: 'admin/resource_categories', referenceProp: 'name' },
  { name: 'File', prop: 'file', type: 'file', url: 'url' }
]
